// WB-TEXT-FMT-001 — whiteboard text styles shared by the Text tool, Ink-to-Text and the toolbar.
export const WB_FONTS = [
  { id: 'marker', label: 'Marker', family: '"Permanent Marker", "Comic Sans MS", cursive', weight: 400, scale: 0.92 },
  { id: 'hand', label: 'Handwritten', family: '"Caveat", "Segoe Script", cursive', weight: 600, scale: 1.25 },
  { id: 'clean', label: 'Clean', family: '"IBM Plex Sans", "Segoe UI", sans-serif', weight: 400, scale: 1 },
  { id: 'bold', label: 'Bold', family: '"IBM Plex Sans", "Segoe UI", sans-serif', weight: 700, scale: 1 },
];
export const DEFAULT_FONT = 'clean';

export const fontDef = (id) => WB_FONTS.find((f) => f.id === id) || WB_FONTS[2];
// Canvas font string; `scale` evens out optical size differences between families (Caveat runs small).
export const fontCss = (size, id) => { const f = fontDef(id); return `${f.weight} ${Math.round(size * f.scale)}px ${f.family}`; };

const PREFS_KEY = 'tf_whiteboard_textprefs_v1:';
export const loadTextPrefs = (userId) => {
  try {
    const raw = userId && localStorage.getItem(`${PREFS_KEY}${userId}`);
    const p = raw ? JSON.parse(raw) : {};
    return { font: WB_FONTS.some((f) => f.id === p.font) ? p.font : DEFAULT_FONT, size: [18, 24, 32, 44].includes(p.size) ? p.size : 24 };
  } catch {
    return { font: DEFAULT_FONT, size: 24 };
  }
};
export const saveTextPrefs = (userId, prefs) => {
  try { if (userId) localStorage.setItem(`${PREFS_KEY}${userId}`, JSON.stringify(prefs)); } catch { /* storage unavailable */ }
};

export const ensureFontsLoaded = () => (typeof document !== 'undefined' && document.fonts
  ? Promise.all(WB_FONTS.map((f) => document.fonts.load(`${f.weight} 24px ${f.family}`).catch(() => null)))
  : Promise.resolve());
